import {
  Container,
  Divider,
  OverviewContainer,
  Title,
} from "./RightPane.styles";
import LoanDetails from "./LoanDetails";
import DocumentsTable from "src/components/DocumentsTable";
import ApplicationProgress from "./ApplicationProgress";
import { useApplication } from "../ApplicationContext";
import LendersList from "./LendersList";
import SendApplicationWidget from "./SendApplicationWidget";
import { APPLICATION_STATUS_KEYS } from "src/constants";

export const RightPane = ({ currentSection }: { currentSection: string }) => {
  const { application } = useApplication();
  const {
    application_id,
    application_status,
    total_amount,
    loan_amount,
    down_payment_amount,
    estimated_monthly_payment,
  } = application;

  let pageTitle = "Application Details";
  if (currentSection === "lenders") pageTitle = "Lenders";

  return (
    <Container>
      <Title>{pageTitle}</Title>
      <Divider />
      {currentSection === "overview" && (
        <OverviewContainer>
          {application_status ===
            APPLICATION_STATUS_KEYS["Ready to submit"] && (
            <SendApplicationWidget />
          )}
          <LoanDetails
            totalAmount={total_amount}
            loanAmount={loan_amount}
            downPaymentAmount={down_payment_amount}
            estimatedMonthlyPayment={estimated_monthly_payment}
          />
          <ApplicationProgress
            applicationId={application_id ?? ""}
            applicationStatus={application_status ?? ""}
          />
        </OverviewContainer>
      )}
      {currentSection === "lenders" && <LendersList />}
      {currentSection === "documents" && (
        <DocumentsTable
          data={{ application_id: application.application_id ?? "" }}
        />
      )}
    </Container>
  );
};
